import { useState } from "react";

import { useMobiel } from "../useMobiel";

/**
 * Het filterblok boven een overzicht.
 *
 * Op de desktop is dat één balk naast het zoekveld. Op een telefoon staat alles onder elkaar, en
 * dan wordt die balk een muur: gemeten op Dier aanwezig (390x844) is het blok 600 pixels hoog en
 * begint het eerste dier pas op 1216 — anderhalf scherm scrollen voordat je iets ziet waarvoor je
 * het scherm opende. Op de vijf verwante overzichten is het 435 tot 546 pixels.
 *
 * Daarom klapt het blok op een telefoon dicht en blijft alleen het zoekveld staan: dat is waar je
 * op een telefoon mee begint. Wie wél wil filteren tikt de knop open.
 *
 * Waarom dit niet in mobile.css staat, waar de rest van de mobiele laag zit: een knop kun je niet
 * met een media query toevoegen. De afspraak blijft wel dezelfde. `toon` is op een breed
 * muisscherm altijd `true` en `mobiel` altijd `false`, dus daar staat de knop niet in de DOM en
 * staan de velden er onveranderd — de desktop kan hier niet van verschuiven.
 */
export function useFilterInklap() {
  const mobiel = useMobiel();
  const [open, setOpen] = useState(false);
  return {
    mobiel,
    open,
    /** Staan de filtervelden er? Op een breed scherm altijd. */
    toon: !mobiel || open,
    wissel: () => setOpen((o) => !o),
  };
}

/**
 * De knop zelf. Het aantal actieve filters staat erop, want een filter dat je niet ziet omdat het
 * blok dicht staat verklaart anders nooit waarom de lijst zo kort is. Dat is dezelfde reden als
 * bij de bestaande "Meer filters"-knop, en met opzet dezelfde vorm.
 */
export function FilterInklapKnop({
  open,
  actief,
  label,
  onClick,
}: {
  open: boolean;
  actief: number;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="fawkes-filter-inklap"
      aria-expanded={open}
      onClick={onClick}
    >
      <span aria-hidden="true">{open ? "▴" : "▾"}</span>
      {label}
      {actief > 0 && <span className="fawkes-filter-inklap__badge">{actief}</span>}
    </button>
  );
}
